import update from 'immutability-helper'
import { parseNumber } from './util'

export const formUpdate = setFunc => ({
  value: updator => evt => {
    if (typeof updator === 'function') {
      setFunc(prev => update(prev, updator(evt.target.value)))
    } else {
      setFunc(prev => update(prev, { [updator]: { $set: evt.target.value } }))
    }
  },

  number: updator => evt => {
    if (typeof updator === 'function') {
      setFunc(prev => update(prev, updator(parseNumber(evt.target.value))))
    } else {
      setFunc(prev => update(prev, { [updator]: { $set: parseNumber(evt.target.value) } }))
    }
  },

  checked: updator => evt => {
    if (typeof updator === 'function') {
      setFunc(prev => update(prev, updator(evt.target.checked)))
    } else {
      setFunc(prev => update(prev, { [updator]: { $set: evt.target.checked } }))
    }
  },

  direct: updator => value => {
    if (typeof updator === 'function') {
      setFunc(prev => update(prev, updator(value)))
    } else {
      setFunc(prev => update(prev, { [updator]: { $set: value } }))
    }
  }
})
